<template>
  <Layout style="height: 100%" class="main">
    <Layout>
      <MHeader style="z-index: 999"></MHeader>
      <Content style="padding: 0px !important">
        <Layout class="main-layout-con">
          <Content style="padding: 0px !important" class="content-wrapper">
            <router-view />
          </Content>
        </Layout>
      </Content>
      <Footer class="footer">
        <div class="footer-container">
          <div class="footer-left">
            <img :src="sysbaseinfo.logoUrl" class="footer-logo" alt="logo" />
            <div class="contact-info">
              <a :href="'mailto:' + sysbaseinfo.email" class="contact-item">
                <i class="contact-icon email-icon"></i>
                {{ sysbaseinfo.email }}
              </a>
              <a :href="'tel:' + sysbaseinfo.phone" class="contact-item">
                <i class="contact-icon phone-icon"></i>
                {{ sysbaseinfo.phone }}
              </a>
            </div>
          </div>
          <div class="footer-right">
            <div class="footer-section">
              <h3 class="footer-title">产品中心</h3>
              <ul class="footer-links">
                <li><a href="javascript:void(0)">麒麟盾工控主机安全防护与审计系统</a></li>
                <li><a href="javascript:void(0)">UWB高性能无线振动传感器</a></li>
                <li><a href="javascript:void(0)">5G采集基站</a></li>
                <li><a href="javascript:void(0)">共享单车管理</a></li>
              </ul>
            </div>
            <div class="footer-section">
              <h3 class="footer-title">关于我们</h3>
              <ul class="footer-links">
                <li><a href="javascript:void(0)">最新动态</a></li>
                <li><a href="javascript:void(0)">关于中科麒麟</a></li>
                <li><a href="javascript:void(0)">联系我们</a></li>
              </ul>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  </Layout>
</template>
<script>
import MHeader from './components/header-bar/MHeader';
import SideMenu from './components/side-menu';
import Swiper from './components/swiper/swiper';
import HeaderBar from './components/header-bar';
import User from './components/user';
import {mapMutations, mapActions} from 'vuex';
// import maxLogo from '@/assets/logo-lyy.png'
import './main.less';
export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    User,
    Swiper,
    MHeader,
  },
  data() {
    return {
      minHeight: window.innerHeight + 'px',
      collapsed: false,
      userName: '',
      playFlag: false,
      chatCounts: 0,
      timer: '',
      intervalId: 0,
      sysbaseinfo: {},
    };
  },
  computed: {
    minLogo() {
      return this.$store.state.systemConfig
        ? this.$store.state.systemConfig.loginLogoUrl
        : '';
    },
    maxLogo() {
      return this.$store.state.systemConfig
        ? this.$store.state.systemConfig.logoUrl
        : '';
    },
    userAvatar() {
      return this.$store.state.avatarImgPath;
    },
    menuList() {
      return this.$store.getters.menuList;
    },
    fullScreen() {
      return this.$store.getters.fullScreen;
    },
    unreadCount() {
      return this.$store.state.unreadCount;
    },
  },
  provide() {
    return {
      turnToPage: this.turnToPage,
    };
  },
  created() {
    // console.log(this.$store.getters.menuList, 'huoahiadhiadhai');
    this.toLogin();
    this.loadData();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    ...mapActions(['onLogin']),
    toLogin() {
      if (this.HXIM_LOGIN) {
        this.onLogin({
          username: JSON.parse(localStorage.getItem('userInfo')).userId,
          password: JSON.parse(localStorage.getItem('userInfo')).password,
        });
      }
    },
    // 两秒查一次有没有新的消息，如果有的话给用户提示
    loadData() {
      this.intervalId = setInterval(() => {
        this.chatCounts = parseInt(localStorage.getItem('chatCount'), 0);
        this.timer = new Date().getTime();
      }, 2000);
    },
    hxChat() {
      this.$router.push({
        name: 'contact',
      });
    },
    changeIsVideoState(v) {
      v ? (this.$data.nowIsVideo = true) : (this.$data.nowIsVideo = false);
    },
    changeColor(name) {// 把className theme1，theme2，theme3挂载在app.vue的<div id="app"></div>上
      document.body.className = name;
      this.$addStorageEvent(2, 'themeName', name);
      localStorage.setItem('app', document.body.className);
      this.reload();
    },
    localStorageDate() {
      localStorage.setItem('app', document.body.className);
    },
    // 存储localStoarge，用于进入系统时，记住用户上一次的选择，自动加载用户上一次选择的主题主题，记得在mounted()里面调用
    ...mapMutations([]),
    ...mapActions(['getUnreadMessageCount']),

    turnToPage(route) {
      let {name, params, query} = {};
      if (typeof route === 'string') {
        name = route;
      } else {
        name = route.name;
        params = route.params;
        query = route.query;
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1]);
        return;
      }
      this.$router.push({
        name,
        params,
        query,
      });
    },
    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    // 控制音频的播放
    audioPlay() {
      let audio = document.getElementById('music');
      if (audio !== null) {
        if (this.playFlag) {
          audio.pause();
          this.playFlag = false;
        } else {
          audio.currentTime = 0;
          audio.play();
          this.playFlag = true;
        }
      }
    },
    // 初始化音频播放状态
    audioInit() {
      this.playFlag = false;
    },
    // 获取服务的数量，若有新增的则音频提醒
    getServiceNumber() {
      let _this = this;
      // 每隔一分钟轮询一次
      setInterval(() => {
        this.$api['medicalRequestService/getServiceNumber']().then(data => {
          if (localStorage.getItem('serviceNumber')) {
            let oldCount = localStorage.getItem('serviceNumber');
            let count = data;
            if (count > oldCount) {
              _this.audioInit();
              _this.audioPlay();
            }
          }
          localStorage.setItem('serviceNumber', data);
        });
      }, 60000);
    },
    getSysbaseinfo() {
      if (localStorage.getItem('sysbaseinfo')) {
        this.sysbaseinfo = JSON.parse(localStorage.getItem('sysbaseinfo'));
        // console.log(this.sysbaseinfo, '系统信息1');
      } else {
        this.$api['ql/getSysbaseinfo']().then(data => {
          let sysbaseinfo = data;
          localStorage.setItem('sysbaseinfo', JSON.stringify(sysbaseinfo));
          this.sysbaseinfo = sysbaseinfo;
          // console.log(this.sysbaseinfo, '系统信息2');
        });
      }
    },
  },
  // watch: {
  //   $route(newRoute) {
  //     this.$refs.sideMenu.updateOpenName(newRoute.name);
  //   }
  // },
  mounted() {
    // 获取未读消息条数
    this.toLogin();
    this.userName = sessionStorage.getItem('displayname');
    this.getUnreadMessageCount();
    this.getSysbaseinfo();
    // this.getServiceNumber()
  },
};
</script>
<style lang="less" scoped>
.footer {
  background: #23283a;
  padding: 0;
  color: #fff;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 40px;
  display: flex;
  justify-content: space-between;
  gap: 80px;
}

.footer-left {
  flex: 0 0 300px;
}

.footer-logo {
  width: 200px;
  height: auto;
  margin-bottom: 30px;
  object-fit: contain;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 15px;
  transition: color 0.3s;
}

.contact-item:hover {
  color: #1e90ff;
}

.contact-icon {
  width: 20px;
  height: 20px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.9;
}

.email-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 24 24'%3E%3Cpath d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/%3E%3C/svg%3E");
}

.phone-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 24 24'%3E%3Cpath d='M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z'/%3E%3C/svg%3E");
}

.footer-right {
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 60px;
}

.footer-section {
  flex: 1;
}

.footer-title {
  color: #1e90ff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 24px;
  position: relative;
}

.footer-title:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 30px;
  height: 2px;
  background: #1e90ff;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
  display: inline-block;
}

.footer-links a:hover {
  color: #1e90ff;
  transform: translateX(5px);
}

@media screen and (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    padding: 40px 20px;
    gap: 40px;
  }

  .footer-left {
    flex: none;
    width: 100%;
    text-align: center;
  }

  .footer-logo {
    width: 160px;
    margin: 0 auto 20px;
  }

  .contact-info {
    align-items: center;
  }

  .footer-right {
    flex-direction: column;
    gap: 30px;
  }

  .footer-title {
    text-align: center;
    margin-bottom: 20px;
  }

  .footer-title:after {
    left: 50%;
    transform: translateX(-50%);
  }

  .footer-links {
    text-align: center;
  }

  .footer-links a {
    font-size: 13px;
  }
}
</style>
